/* ========================================================================
 * FD:          dates
 * Child:       --
 * Version:     1.0
 * ========================================================================
 * ========================================================================
 * 2/22/2016: creation
*/


/* ========================================================================
 *  vars
 * ========================================================================
*/
Date.monthAbbreviations = new Array('Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec');
Date.monthFullAbbreviations = new Array('January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December');
Date.dayAbbreviations = new Array('Sun', 'Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat');
Date.dayAbbreviationsLong = new Array('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday');
Date.OneDay = 1000 * 60 * 60 * 24;

/* ========================================================================
 *  date clean up
 * ========================================================================
*/
//  leading zero
Date.LZ = function (x) {
    return (x < 0 || x > 9 ? "" : "0") + x;
};




/* ========================================================================
 *  display
 * ========================================================================
*/


//  display date in mm/dd/yyyy format
Date.prototype.getDateFriendly = function () {
    return (Date.LZ(this.getMonth() + 1)) + "/" + Date.LZ(this.getDate()) + '/' + this.getFullYear();
}


//  display date in mm/dd format
Date.prototype.getDateMonth = function () {
    return (Date.LZ(this.getMonth() + 1)) + "/" + Date.LZ(this.getDate());
}




// display monday in mm/dd/yyyy format
Date.prototype.getMondayDateFriendly = function () {
    var fullDate = new Date(this.setDate(this.getDate() - this.getDay() + (this.getDay() === 0 ? -6 : 1))); // adjust when day is sunday
    return (Date.LZ(fullDate.getMonth() + 1)) + "/" + Date.LZ(fullDate.getDate()) + "/" + fullDate.getFullYear();
}


// display date in mm/yyyy format
Date.prototype.getMonthYearDateFriendly = function () {
    return (Date.LZ(this.getMonth() + 1)) + "/" + this.getFullYear();
}

// display year
Date.prototype.getYearFriendly = function () {
    return this.getFullYear();
}


// display monday in mm/dd/yyyy format
Date.prototype.getMondayDateFriendly = function () {
    var fullDate = new Date(this.setDate(this.getDate() - this.getDay() + (this.getDay() === 0 ? -6 : 1))); // adjust when day is sunday
    return (Date.LZ(fullDate.getMonth() + 1)) + "/" + Date.LZ(fullDate.getDate()) + "/" + fullDate.getFullYear();
}


//  display date in DayName, Month Abr, Day, yy
Date.prototype.getFullDateFriendlyLong = function () {
    return Date.dayAbbreviationsLong[this.getDay()] + ', ' + Date.monthAbbreviations[this.getMonth()] + ' ' + Date.LZ(this.getDate()) + ', ' + this.getFullYear();
}


//  display date in Day Abr, Month Abr, Day, yy
Date.prototype.getDayAbrFullDateFriendlyLong = function () {
    return Date.dayAbbreviations[this.getDay()] + ', ' + Date.monthAbbreviations[this.getMonth()] + ' ' + Date.LZ(this.getDate()) + ', ' + this.getFullYear();
}

//  display date in Month Abr, Day, yy
Date.prototype.getAbrFullDateFriendlyLong = function (label) {
    return label[Date.monthAbbreviations[this.getMonth()]] + ' ' + Date.LZ(this.getDate()) + ', ' + this.getFullYear();
}


//  display date in DayName, Month Abr, Day, yy
Date.prototype.getFullDateFriendly = function () {
    return Date.dayAbbreviations[this.getDay()] + ', ' + Date.monthAbbreviations[this.getMonth()] + ' ' + Date.LZ(this.getDate()) + ', ' + this.getFullYear();
}


//  display date in DayName, Month Abr, Day
Date.prototype.getDayMonthNum = function () {
    return Date.dayAbbreviations[this.getDay()] + ', ' + Date.monthAbbreviations[this.getMonth()] + ' ' + Date.LZ(this.getDate());
}


//  display date in DayName, Month Abr, Day, yy hh mm ss mm
Date.prototype.getFullDateTimeFriendly = function () {
    return Date.dayAbbreviations[this.getDay()] + ', ' + Date.monthAbbreviations[this.getMonth()] + ' ' + Date.LZ(this.getDate()) + ', ' + this.getFullYear() + ' ' +
        this.getHours() + ":" + this.getMinutes() + ":" + this.getSeconds() + ":" + this.getMilliseconds();
}

//  display date in Day Abr, Month Abr, Day, yy
Date.prototype.getDayAbrFullDateFriendlyLong = function () {
    return Date.dayAbbreviations[this.getDay()] + ', ' + Date.monthAbbreviations[this.getMonth()] + ' ' + Date.LZ(this.getDate()) + ', ' + this.getFullYear();
}

//  display date in  Month Abr, yy
Date.prototype.getMonthDateFriendly = function () {
    return Date.monthAbbreviations[this.getMonth()] + ', ' + this.getFullYear();
}

//  display date in  Month Full, yy
Date.prototype.getMonthDateFriendlyFull = function () {
    return Date.monthFullAbbreviations[this.getMonth()] + ', ' + this.getFullYear();
}


//  get day abbr
Date.prototype.getDayAbbreviation = function (day) {
    return Date.dayAbbreviations[day];
}





//  is weekend
Date.prototype.isWeekend = function () {
    return (this.getDay() == 6 || this.getDay() == 0) ? true : false;
}


//  is sunday
Date.prototype.isSunday = function () {
    return (this.getDay() == 0) ? true : false;
}


//  adjust day value
Date.prototype.adjustDayValue = function (days, xSunday) {
    var newDate = new Date(this.setDate(this.getDate() + days));
    //  xclude sunday
    if (xSunday) {
        if (newDate.getDay() == 0 && days < 0) {
            newDate = new Date(this.setDate(this.getDate() - 1));
        }

        if (newDate.getDay() == 0 && days > 0) {
            newDate = new Date(this.setDate(this.getDate() + 1));
        }
    }
    return newDate;
}


//  adjust month value
Date.prototype.adjustMonthValue = function (months) {
    this.setMonth(this.getMonth() + months);
    this.setDate(1);
    return this;
}

//  is date equal: ignores time
Date.prototype.isEqual = function (testDate) {
    return (
        this.getFullYear() === testDate.getFullYear() &&
        this.getMonth() === testDate.getMonth() &&
        this.getDate() === testDate.getDate()
    );
}

// Get # days between two dates
Date.prototype.getDaysBetween = function (testDate) {
    return Math.floor(new Date(this - testDate).getTime() / Date.OneDay);
}

Date.prototype.getMonthsBetween = function (testDate) {
    var months;
    months = (this.getFullYear() - testDate.getFullYear()) * 12;
    months -= testDate.getMonth();
    months += this.getMonth();
    return months;
}


//  is valid date
Date.prototype.isValid = function () {
    // An invalid date object returns NaN for getTime() and NaN is the only
    // object not strictly equal to itself.
    return this.getTime() === this.getTime();
};


//  is after
Date.prototype.isAfter = function (testDate) {
    if (testDate == null) return false;
    return (this.getTime() > testDate.getTime());
};


//  add day
Date.prototype.addDay = function (days) {
    // var d = new Date(this);
    return this.setDate(this.getDate() + (days));
}


// get last day of month
Date.prototype.getlastDayOfMonth = function () {
    return 32 - new Date(this.getFullYear(), this.getMonth(), 32).getDate();
}

// get first day of month
Date.prototype.getFirstDayOfMonth = function () {
    return new Date(this.getFullYear(), this.getMonth(), 1);
}

// get first day of week
Date.prototype.getFirstDayOfWeek = function () {
    return new Date(this).adjustDayValue(-1 * this.getDay());
}

//  get first day number of month
Date.prototype.getFirstDayNumber = function () {
    var firstDay = new Date(this.getFullYear(), this.getMonth(), 1);
    return firstDay.getDay();
}
